function addDataAccessor(object, name, defaultValue, enumerable) {
  const _name = `_${name}`;

  Object.defineProperty(object, _name, {
    configurable: true,
    value: defaultValue,
    writeable: true
  });
  Object.defineProperty(object.prototype, name, {
    enumerable: enumerable,
    get: function get() { return this[_name]; },
    set: function set(value) { this[_name] = value; }
  });
}

function addToString(object) {
  const { name } = object.constructor;

  Object.defineProperty(object.prototype, "toString", {
    value: function toString() { return `[object ${name}]`; }
  });

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    object.prototype[Symbol.toStringTag] = name;
  }
}

(function AbortSignalPolyfill(AS) {
  function onabortFn(e) {
    const self = this;
    const { onabort } = self;

    self.aborted = true;

    if (typeof onabort === "function") {
      onabort.call(self, e);
    }
  }

  function AbortSignal() {
    const self = this;

    self.addEventListener("abort", onabortFn.call(self));
  }

  if (typeof AS !== "function") {
    addDataAccessor(AbortSignal, "aborted", false);
    addDataAccessor(AbortSignal, "onabort", null);
    addToString(AbortSignal);
    Object.setPrototypeOf(AbortSignal.prototype, EventTarget);
    AbortSignal.prototype.constructor = AbortSignal;
    AbortSignal.abort = function abort() {
      const signal = new AbortSignal();

      signal.aborted = true;

      return signal;
    };

    window.AbortSignal = AbortSignal;
  }
})(window.AbortSignal);

(function AbortControllerPolyfill(AC, R) {
  function AbortError(message) {
    const self = this;
    const error = Error.call(self, message);

    self.name = self.constructor.name;
    self.message = error.message;
    self.stack = error.stack;
  }

  function AbortController() {}

  if (!AC || (typeof R === 'function' && !Object.hasOwnProperty.call(R.prototype, 'signal'))) {
    addToString(AbortError);
    Object.setPrototypeOf(AbortError.prototype, DOMException.prototype);
    AbortError.prototype.constructor = AbortError;

    addDataAccessor(AbortController, "signal", new AbortSignal());
    addToString(AbortController);
    Object.defineProperty(AbortController.prototype, "abort", {
      enumerable: true,
      value: function abort() {
        // like in Safari 11, this won't actually abort a fetch. Can't be helped.
        const { signal } = this;

        if (!signal.aborted) {
          signal.dispatchEvent(new Event("abort"));
        }

        return Promise.reject(new AbortError("abort"));
      }
    });
    Object.setPrototypeOf(AbortController.prototype, Object.prototype);
    AbortController.prototype.constructor = AbortController;

    window.AbortController = AbortController;
  }
})(window.AbortController, window.Request);



// WEBPACK FOOTER //
// ./core/abort-controller.js